<template>
  <div>
    <b-row class="m-0 pt-3 justify-content-center">
      <div>
       <b-img-lazy :src="require(`@/assets/logos/eatDoradoLogo.png`)" class="" style=" max-width: 90%; width: 300px; height: 200px" fluid alt="eatDorado Logo"></b-img-lazy>  
      </div>
    </b-row>
    <b-row class="m-0 mt-3 justify-content-center">
      <h1>Konto aktivieren</h1>
    </b-row>
    <b-row class="m-0 mt-4 justify-content-center">
      
      <div style="width: 600px; max-width: 100%" class="mx-3">
        <h4 class="text-center">Fülle dein Profil aus und aktiviere Dein Konto:</h4>
        <div class="mt-3" v-if="authMessage">
          <h4 class="text-center text-danger">{{ authMessage }}</h4>
        </div>
        <div>
          <b-form class="mt-3" @submit.prevent="submitForm()">
            
            <b-form-group id="input-group-3" label="Vorname*">
              <b-form-input
                :state="form.firstname ? true : false"
                v-model="form.firstname"
                placeholder="Vorname eingeben..."
                type="text"
                required
              ></b-form-input>
            </b-form-group>

            <b-form-group id="input-group-3" label="Nachname*">
              <b-form-input
                :state="form.lastname ? true : false"
                v-model="form.lastname"
                placeholder="Nachname eingeben..."
                type="text"
                required
              ></b-form-input>
            </b-form-group>

            <p class="m-0">Adresse (optional)</p>
              <vue-google-autocomplete
                  class="mb-3 mt-1"
                  :class="Object.keys(form.adressData).length === 0 ? 'border-danger' : 'border-success'"
                  id="map"
                  classname="form-control"
                  :placeholder="getPlaceholder()"
                  v-on:placechanged="getAddressData"
                  country="de"
              >
              </vue-google-autocomplete>


            <b-form-group
              label="Mobilnummer*"
              description="Das Restaurant benötigt deine Mobilnummer für eventuelle Rückfragen und zur Bestätigung der Bestellung. An diese Nummer wird ein Code per SMS gesendet."
              > 
                <b-row>
                  <b-col cols="2" class="pr-0">
                    <b-form-input
                      v-model="preNumber"
                      type="text"
                      disabled
                      placeholder="+49"
                      required
                    ></b-form-input>
                  </b-col>
                  <b-col cols="10" class="pl-1">
                    <b-form-input
                      name="phone"
                      :state="form.phone.length < 10 ? false : true"
                      v-model="form.phone"
                      type="text"
                      placeholder="Mobilnummer eingeben..."
                      required
                    ></b-form-input>
                    
                  </b-col>
                </b-row>
                <b-form-invalid-feedback>
                  An die Angegebene Mobilnummer konnte keine SMS gesendet werden, bitte überprüfe die Richtigkeit der Nummer.
                </b-form-invalid-feedback>
                
              </b-form-group>

            <b-form-group id="input-group-3" label="Passwort*" >
              <b-form-input
                :state="statePassword"
                @input="registerStatePassword"
                v-model="form.password"
                placeholder="Passwort eingeben..."
                type="password"
                required
              ></b-form-input>
              <b-form-invalid-feedback>
                Passwortbedingungen nicht erfüllt
              </b-form-invalid-feedback>
            </b-form-group>

            <div class="mb-3 p-0 border bg-light rounded p-2">
              <b-row class="m-0 mb-1 justify-content-start">
                <font-awesome-icon :class="passwordChecks.upperCase ? 'text-success' : 'text-danger'" :icon="passwordChecks.upperCase ? 'check' : 'times'" />
                <p class="ml-2 m-0">Großbuchstabe</p>
              </b-row>
              <b-row class="m-0 my-1 justify-content-start">
                <font-awesome-icon :class="passwordChecks.lowerCase ? 'text-success' : 'text-danger'" :icon="passwordChecks.lowerCase ? 'check' : 'times'" />
                <p class="ml-2 m-0">Kleinbuchstabe</p>
              </b-row>
              <b-row class="m-0 my-1 justify-content-start">
                <font-awesome-icon :class="passwordChecks.number ? 'text-success' : 'text-danger'" :icon="passwordChecks.number ? 'check' : 'times'" />
                <p class="ml-2 m-0">Zahl</p>
              </b-row>
              <b-row class="m-0 mt-1 justify-content-start">
                <font-awesome-icon :class="passwordChecks.passwordLength ? 'text-success' : 'text-danger'" :icon="passwordChecks.passwordLength ? 'check' : 'times'" />
                <p class="ml-2 m-0">mindestens 8 Zeichen</p>
              </b-row>
            </div>
            
            <b-form-group id="input-group-4" label="Passwort wiederholen*" label-for="input-4">
              <b-form-input
                :state="!form.passwordRepeat || form.password != form.passwordRepeat? false : true"
                id="input-4"
                v-model="form.passwordRepeat"
                placeholder="Passwort wiederholen..."
                type="password"
                required
              ></b-form-input>
              <b-form-invalid-feedback>
                {{ registerInvalidFeedbackPasswordConfirm }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group >
              <b-form-checkbox-group
                :state="!form.checked.length > 0 ? false : true"
                v-model="form.checked"
                id="dsgvo-accepted"
                required
              >
              <b-form-checkbox value="me">Die Informationen zum <a href="/datenschutz" target="_blank">Datenschutz</a> habe ich gelesen und stimme zu.*</b-form-checkbox>
              </b-form-checkbox-group>
            </b-form-group>

            <small class="m-0">Mit * markierte Felder sind Pflichtfelder</small>

            <b-button type="submit" :disabled="validateForm()" style="width: 100%" size="md" variant="dark">Konto aktivieren</b-button>
            <!-- <p class="text-center m-0 mb-3 mt-5">Du hast schon ein Konto?</p>
            <b-button style="width: 100%" size="md" variant="dark" @click="$router.push('/login').catch(err => {})">Zur Anmeldung</b-button> -->
          </b-form>
        </div>
      </div>
    </b-row>
    <Footer></Footer>
  </div>
</template>

<script>

import Footer from '@/components/Footer'
import coreData from '@/mixins/coreDataMixin'
import VueGoogleAutocomplete from 'vue-google-autocomplete'

export default {
  name: 'Activate',
  mixins: [coreData],
  data: () => {
    return {
      preNumber: '+49',
      registerInvalidFeedbackPassword: '',
      statePassword: false,
      form: {
        password: '',
        passwordRepeat: '',
        checked: [],
        firstname: '',
        lastname: '',
        phone: '',
        adressData: {}
      },
      passwordChecks: {
        upperCase: false,
        lowerCase: false,
        number: false,
        passwordLength: false
      }
    }
  },
  components: {
    Footer,
    VueGoogleAutocomplete
  },
  computed: {
    stateAdress(){
      if(!this.form) return false
      var vm = this
      return Object.keys(vm.form.adressData).length === 0 ? false : true
    },
    accountCreated(){
      return this.$store.getters.accountCreated
    },
    darkMode(){
      return this.$store.getters.darkMode
    },
    contactFormSent(){
      return this.$store.getters.contactFormSent
    },
    
    registerStatePasswordConfirm() {
      if(this.authMessagePassword){
        return false
      }
      if(this.registerPasswordConfirm.length == 0){
        return false
      }
      return this.registerPasswordConfirm == this.registerPassword ? true : false
    },

    registerInvalidFeedbackPasswordConfirm(){
      if(this.form.passwordRepeat.length == 0) return 'Passwort wiederholen'
      if(this.form.password !== this.form.passwordRepeat) return 'Passwörter sind unterschiedlich'
      return ''
    },

  },
  watch:{
    contactFormSent(){
      if(this.contactFormSent){
        this.form = {}
      }
    }
  },
  mounted() {
    // this.form.adressData = JSON.parse(localStorage.getItem('adressData'))
    // console.log(this.$route.query.token)
  },
  methods: {
    validateForm(){
      if(!this.form.firstname || !this.form.lastname || !this.form.phone || !this.statePassword || (this.form.password != this.form.passwordRepeat) || this.form.checked.length == 0) return true
      return false
    },
    getAddressData: function (addressData) {
      this.form.adressData = addressData;
      localStorage.setItem('adressData', JSON.stringify(this.adressData))
    },
    getPlaceholder(){
      if(this.adressData){
        return this.adressData.locality + ' , ' + this.adressData.country
      }
      return 'Gebe deine Adresse ein'
    },
    registerStatePassword() {
      console.log('change')
      this.registerInvalidFeedbackPassword = 'Bedingungen: ' 

      var hasUpperCase = /[A-Z]/.test(this.form.password);
      hasUpperCase ? this.passwordChecks.upperCase = true : this.passwordChecks.upperCase = false

      var hasLowerCase = /[a-z]/.test(this.form.password);
      hasLowerCase ? this.passwordChecks.lowerCase = true : this.passwordChecks.lowerCase = false


      var hasNumbers = /\d/.test(this.form.password);
      hasNumbers ? this.passwordChecks.number = true : this.passwordChecks.number = false

      this.form.password.length >= 8 ? this.passwordChecks.passwordLength = true : this.passwordChecks.passwordLength = false
      
      if (!hasUpperCase || !hasLowerCase || !hasNumbers || this.form.password.length < 8 ){
        return this.statePassword = false
      }

      return this.statePassword = true

    },
    submitForm(){
      if(this.form.checked.length == 0) return
      if(!this.$route.query.token) return
      
      var testString = this.form.phone.substring(0,3)
      var mobileNumber = this.preNumber + parseInt(this.form.phone, 10)
      if(testString === '+49'){
        mobileNumber = this.form.phone
      }

      const payload = {
        firstname: this.form.firstname,
        lastname: this.form.lastname,
        phone: mobileNumber,
        adressData: this.form.adressData,
        password: this.form.password,
        passwordRepeat: this.form.passwordRepeat,
        token: this.$route.query.token
      }
      this.$store.dispatch('createAccount', payload)
    } 
  }
}
</script>